import { Button, Col, Row } from "reactstrap";
import { Href, LearnMore, SecureAppDescription, SecureAppText, SecureAppTitle } from "../../Constants/Constants";
import SvgIcon from "../CommonComponents/SvgIcon";

const SecureApp = () => {
  return (
    <section className="section-pb-space secure-app-main">
      <div className="custom-container">
        <Row>
          <Col xl="5" lg="5" className="offset-xl-7 offset-lg-7">
            <div className="secure-app-content">
              <div>
                <div className="ply-main">
                  <div className="ply-content">
                    <SvgIcon iconId="landing-secure" />
                  </div>
                  <h3>{SecureAppTitle}</h3>
                </div>
                <h2>{SecureAppText}</h2>
                <h4>{SecureAppDescription}</h4>
                <Button tag={"a"} className="pricing-btn" href={Href}>{LearnMore}</Button>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default SecureApp;
